import React, { Component } from 'react';
import Carousel from 're-carousel'
import slide1 from './home-slide-1.jpg';
import slide2 from './home-slide-2.jpg';
import slide3 from './home-slide-3.jpg';
import slide4 from './home-slide-4.jpg';
import slide5 from './home-slide-5.jpg';
import slide6 from './home-slide-6.jpg';


class MainImage extends Component {

  render() {
    return (
        <div className="mainImage">
          <div className="carousel-wrapper">
            <Carousel
              loop
              auto
              duration={2000}
              interval={4000}>
              <img alt='' src={slide1} />
              <img alt='' src={slide2} />
              <img alt='' src={slide3} />
              <img alt='' src={slide4} />
              <img alt='' src={slide5} />
              <img alt='' src={slide6} />
            </Carousel>
          </div>
        </div>
    );
  }
}

export default MainImage;






// WEBPACK FOOTER //
// ./src/components/MainImage/MainImage.js